<apcam-shared-dialog-shell [config]="dialogShellConfig">
    <div class="border border-gray-200 overflow-x-auto">
        <mat-table [dataSource]="dataSource" matSort [style.minWidth]="'600px'">
            <!-- ID Column -->
            <ng-container matColumnDef="id">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                    [style.flexGrow]="flexGrowCols['id']">
                    {{ 'shared.notificationDialog.table.id' | translate }}
                </th>
                <td
                    mat-cell
                    *matCellDef="let notification"
                    [style.flexGrow]="flexGrowCols['id']">
                    {{ notification.id }}
                </td>
            </ng-container>

            <!-- Created at Column -->
            <ng-container matColumnDef="createdAt">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                    [style.flexGrow]="flexGrowCols['createdAt']">
                    {{
                        'shared.notificationDialog.table.createdAt' | translate
                    }}
                </th>
                <td
                    mat-cell
                    *matCellDef="let notification"
                    [style.flexGrow]="flexGrowCols['createdAt']">
                    {{ notification.createdAt | translateDate }}
                </td>
            </ng-container>

            <!-- Message Column -->
            <ng-container matColumnDef="message">
                <th mat-header-cell *matHeaderCellDef>
                    {{ 'shared.notificationDialog.table.message' | translate }}
                </th>
                <td mat-cell *matCellDef="let notification">
                    {{ notification.message }}
                </td>
            </ng-container>

            <!-- Row definition -->

            <mat-header-row
                *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let notification; columns: displayedColumns">
            </mat-row>
            <!-- Row shown when there is no matching data. -->
            <div *matNoDataRow class="flex justify-center">
                <td [attr.colspan]="displayedColumns.length">
                    {{
                        'shared.notificationDialog.table.noNotification'
                            | translate
                    }}
                </td>
            </div>
        </mat-table>

        <mat-paginator
            [hidden]="
                dataSource.data.length <= TableConfigService.TableRowDefault
            "
            [pageSizeOptions]="TableConfigService.TableRowsOptions"
            attr.aria-label="{{
                'shared.notificationDialog.paginator' | translate
            }}"></mat-paginator>
    </div>
</apcam-shared-dialog-shell>
